import AddressLookupForm from '@/form/AddressLookupForm';
import CreateEquipmentForm from '@/form/CreateEquipmentForm';
import { EntryForm } from '@/form/EntryForm';
import EquipmentAttributeForm from '@/form/EquipmentAttributeForm';
import EquipmentForm from '@/form/EquipmentForm';
import { EquipmentListForm } from '@/form/EquipmentListForm';
import { ExitForm } from '@/form/ExitForm';
import IfForm from '@/form/IfForm';
import { ImageForm } from '@/form/ImageForm';
import InfoForm from '@/form/InfoForm';
import { InitialRoomsForm } from '@/form/InitialRoomsForm';
import InputForm from '@/form/InputForm';
import { ReturnForm } from '@/form/ReturnForm';
import RoomForm from '@/form/RoomForm';
import { RoomStarterSelectionForm } from '@/form/RoomStarterSelectionForm';
import ScanForm from '@/form/ScanForm';
import SelectForm from '@/form/SelectForm';
import SetForm from '@/form/SetForm';
import SubGuideForm from '@/form/SubGuideForm';
import YesNoForm from '@/form/YesNoForm';
import type { AppNodeType, SpaceId } from '@rock/types';
import type { NodeTypes } from '@xyflow/react';
import type { ComponentType } from 'react';
import AddressLookupNode from './AddressLookupNode';
import { CreateEquipmentNode } from './CreateEquipmentNode';
import { EntryNode } from './EntryNode';
import EquipmentAttributeNode from './EquipmentAttributeNode';
import { EquipmentListNode } from './EquipmentListNode';
import EquipmentNode from './EquipmentNode';
import { ExitNode } from './ExitNode';
import IfNode from './IfNode';
import { ImageNode } from './ImageNode';
import InfoNode from './InfoNode';
import { InitialRoomsNode } from './InitialRoomsNode';
import InputNode from './InputNode';
import { ReturnNode } from './ReturnNode';
import RoomNode from './RoomNode';
import { RoomStarterSelectionNode } from './RoomStarterSelectionNode';
import ScanNode from './ScanNode';
import SelectNode from './SelectNode';
import SetNode from './SetNode';
import SubGuideNode from './SubGuideNode';
import type { AppNode } from './types';
import YesNoNode from './YesNoNode';

export * from './types';

export const nodeTypes = {
    'address-lookup': AddressLookupNode,
    'create-equipment': CreateEquipmentNode,
    entry: EntryNode,
    'equipment-attribute': EquipmentAttributeNode,
    equipment: EquipmentNode,
    'equipment-list': EquipmentListNode,
    exit: ExitNode,
    if: IfNode,
    image: ImageNode,
    info: InfoNode,
    'initial-rooms': InitialRoomsNode,
    input: InputNode,
    return: ReturnNode,
    room: RoomNode,
    'room-starter-selection': RoomStarterSelectionNode,
    scan: ScanNode,
    select: SelectNode,
    set: SetNode,
    'sub-guide': SubGuideNode,
    'yes-no': YesNoNode,
} satisfies NodeTypes satisfies { [k in AppNodeType]: ComponentType<any> };

export const nodeFormTypes: Record<AppNodeType, ComponentType<NodeFormProps<any>>> = {
    'address-lookup': AddressLookupForm,
    'create-equipment': CreateEquipmentForm,
    entry: EntryForm,
    'equipment-attribute': EquipmentAttributeForm,
    equipment: EquipmentForm,
    'equipment-list': EquipmentListForm,
    exit: ExitForm,
    if: IfForm,
    image: ImageForm,
    info: InfoForm,
    'initial-rooms': InitialRoomsForm,
    input: InputForm,
    return: ReturnForm,
    room: RoomForm,
    'room-starter-selection': RoomStarterSelectionForm,
    scan: ScanForm,
    select: SelectForm,
    set: SetForm,
    'sub-guide': SubGuideForm,
    'yes-no': YesNoForm,
};

export type NodeFormProps<T extends AppNode> = {
    spaceId: SpaceId;
    flowId: string;
    node: T;
    updateNode: (node: T) => Promise<void>;
    cancelUpdate: () => void;
};
